import { DeviceModel } from 'types/devices'

export const getIsMobileDevice = (deviceModel: string | null | undefined) => {
  return deviceModel === DeviceModel.ANDROID || deviceModel === DeviceModel.IOS
}
